export default {"src":"/_next/static/image/public/img/play-arrow.574bc87d23b41e1a0fd974a4c67b552e.svg","height":192,"width":192};